export default __webpack_public_path__ + "static/media/video_upload_icon.f2824584.png";